var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2460D8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.761 5.306l-.13-.13-.102-.103L8.627 3.17c-.233-.233-.467-.465-.699-.7-.079-.078-.158-.157-.235-.237L7.46 2l-.861.862L5.354 4.11l-1.42 1.42-1.418 1.42-1.232 1.233A235107088.562 235107088.562 0 0 1 .182 9.285c-.09.091-.17.164-.175.312-.016.429 0 .86.002 1.29l.002 1.68v.1c0 .178.15.33.329.33l1.28.001L3.303 13c.051 0 .099.001.148-.005a.37.37 0 0 0 .208-.109l.163-.163.75-.75 1.16-1.163 1.39-1.391L8.56 7.98 9.86 6.68l.984-.984c.05-.051.103-.104.156-.155-.082-.078-.16-.155-.239-.234zM12.743 2.26l-.354-.354L11.145.66 10.76.275a.91.91 0 0 0-.262-.191c-.265-.12-.595-.118-.84.052-.134.094-.245.22-.36.335l-.583.582L8 1.766l2.808 2.81.212.212.212.212.304-.304.989-.99.22-.22.01-.01.012-.012a.863.863 0 0 0-.024-1.205z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.c06f37be354e577214999cf26110e474.svg";
export { ForwardRef as ReactComponent };